/* eslint-disable prefer-promise-reject-errors */
import config from 'src/config';
import { postRequest, putRequest } from 'src/utils/RequestUtil';

export const mastersSearchAPI = function (data) {
    const url = `${config.baseUrl}masters/search`;
    return postRequest({
        url,
        data: {
            ...data,
            sortBy: 'ts',  // or another timestamp field
            sortOrder: -1,  // descending order
        },
    });
};

export const mastersCreateAPI = function (data) {
    const url = `${config.baseUrl}masters`;
    return postRequest({
        url,
        data,
    });
};

export const mastersUpdateAPI = function ({
    masterId,
    data,
}) {
    const url = `${config.baseUrl}masters/${masterId}`;
    return putRequest({
        url,
        data,
    });
};
